/* @flow */

import {useQuery} from '@apollo/react-hooks';
import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSuggestedReplies as GetSuggestedRepliesQuery,
    GetSuggestedRepliesVariables as GetSuggestedRepliesQueryVariables,
} from 'nutshell-graphql-types';

import GET_SUGGESTED_REPLIES from '../queries/get-suggested-replies.graphql';

export const useGetSuggestedReplies = (emailId: string, skip?: boolean = false) => {
    const {
        data,
        loading: isLoading,
        error,
        refetch,
    } = useQuery<GetSuggestedRepliesQuery, GetSuggestedRepliesQueryVariables>(
        GET_SUGGESTED_REPLIES,
        {
            variables: {input: {emailId: emailId}},
            fetchPolicy: 'cache-and-network',
            skip,
        }
    );

    const suggestedReplies = data ? data.suggestedReplies : null;

    return {
        suggestedEmailReplies: suggestedReplies,
        isLoading,
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
